export enum QueuedModalTypeEnum {
  CONTACT = 'CONTACT',
  LEARN = 'LEARN',
}
